module.exports = __webpack_public_path__ + "img/logo.201aea0a.png";